import React from "react";
import { Link } from "react-router-dom";

const Shell = ({ title, updated, children }) => (
  <div className="min-h-screen bg-black text-white px-6 py-16">
    <div className="max-w-2xl mx-auto">
      <Link to="/" className="text-xs text-white/40 uppercase tracking-widest">&larr; Boltorium</Link>
      <h1 className="text-3xl font-black mt-6 mb-2">{title}</h1>
      <p className="text-xs text-white/40 mb-8">Last updated: {updated}</p>
      <div className="space-y-5 text-sm text-white/70 leading-relaxed">{children}</div>
      <p className="mt-12 text-xs text-white/40">
        Boltorium is operated by Kyle Petalik (Boltorium), Powell River, BC, Canada. Contact:{" "}
        <a className="underline" href="mailto:kyleadmin@boltorium.co">kyleadmin@boltorium.co</a>
      </p>
    </div>
  </div>
);

export function Privacy() {
  return (
    <Shell title="Privacy Policy" updated="August 2026">
      <p>Boltorium tracks rides and rewards riders with Boltz. Here is what we collect and why.</p>
      <p><strong>Account data.</strong> Your email, display name and profile details you enter, used to sign you in and run your account.</p>
      <p><strong>Location and ride data.</strong> When you record a ride we collect GPS location, distance, speed and timestamps from your device. That is what makes ride tracking, airdrop pickups and Boltz rewards work. Location is collected only while you use ride tracking features.</p>
      <p><strong>Payments.</strong> Purchases are processed by Stripe. We never see or store your full card details.</p>
      <p><strong>Solana wallet.</strong> If you connect a Solana wallet we store your public wallet address so we can deliver Boltz and other on-chain rewards. We never have your private keys or seed phrase.</p>
      <p><strong>Analytics.</strong> We use product analytics to understand how the app is used and fix problems.</p>
      <p><strong>Sharing.</strong> We do not sell your data. We share it only with the providers needed to run Boltorium (hosting, Stripe, analytics) or where required by law.</p>
      <p><strong>Your choices.</strong> Email us to request a copy of your data or deletion of your account.</p>
    </Shell>
  );
}

export function Terms() {
  return (
    <Shell title="Terms of Service" updated="August 2026">
      <p>By using Boltorium you agree to these terms. Boltorium is an independent project operated by Kyle Petalik; it is not an incorporated company.</p>
      <p><strong>Ride safely.</strong> Boltorium is a ride tracking and rewards app. You are responsible for riding legally and safely and for obeying traffic laws. Never chase airdrops or rewards at the expense of your safety or anyone else&apos;s.</p>
      <p><strong>Boltz and rewards.</strong> Boltz are in-app reward points, some of which may be represented on Solana. They are not an investment, not a security, and carry no guaranteed monetary value. Reward rates, airdrops and features can change or end at any time.</p>
      <p><strong>Wallets.</strong> If you connect a Solana wallet you are responsible for its security. Blockchain transactions are irreversible; we cannot recover lost keys or reverse transfers.</p>
      <p><strong>Payments.</strong> Paid features are handled by Stripe. Prices are shown before you buy. Refunds are handled case by case &mdash; email us.</p>
      <p><strong>Fair use.</strong> Do not cheat ride tracking (spoofed GPS, fake rides, bots), abuse other riders, or attack the service. Accounts that do may be suspended.</p>
      <p><strong>No warranty.</strong> Boltorium is provided as is, without warranty. To the extent permitted by law we are not liable for damages arising from your use of the app.</p>
      <p>These terms are governed by the laws of British Columbia, Canada.</p>
    </Shell>
  );
}

export default Privacy;
